/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { pure } from 'recompose'
import CheckInAction from '../../../action/check_in/index'
import r from '../../../util/Renderer'
import Nations from '../../../util/Nations'
import Occupations from '../../../util/Occupations'
import { Checkbox, FileInput, RadioGroup, RadioInput, TextInput } from '../../atoms'
import { CarefulButton, NormalButton } from 'ui-library/dist/external/components'

function InputForms(props) {
  return props.forms
    ? props.forms.map((v, index) => (
        <PureInputForm
          key={index + 1}
          index={index + 1}
          reservationId={props.reservationId}
          token={props.token}
          onConfirmDeletion={CheckInAction.confirmDeletion}
          onCloseDeletionDialog={CheckInAction.closeDeletionDialog}
          onFormDeletion={CheckInAction.deleteForm}
          prefectures={props.prefectures}
        >
          {v}
        </PureInputForm>
      ))
    : null
}

const PureInputForm = pure(InputForm)

function InputForm(props) {
  const form = props.children
  const reservationId = props.reservationId
  const token = props.token
  const index = props.index

  function onChange(e) {
    CheckInAction.onEdit(token, e, index)
  }

  return (
    <div className="guestform">
      <div className="guestform__label">
        <div className="circle" />
        <div className="guestMember">
          宿泊者#
          {index} Guest #{index}
        </div>
      </div>

      {/* id=1 は最初のフォームなので削除できない*/}
      {r.renderIf(index !== 1)(
        <div className="guestform__delete" onClick={e => props.onConfirmDeletion(e, index)}>
          <DeleteDialog onCloseDeletionDialog={props.onCloseDeletionDialog} onFormDeletion={props.onFormDeletion} index={index}>
            {form}
          </DeleteDialog>
        </div>
      )}

      <div className="guestform__inputform">
        <div className="inner container">
          <div className="row">
            <TextInput className="textInput form1" value={form.name} type="text" name="name" label={'お名前 Name'} option="required" onChange={e => onChange(e)} />
            <div className="textInput textInput form1">
              <div className="textInput__label textInput__label- textInput__label-">
                性別 Gender<span style={{ color: 'red' }}>&nbsp;*</span>
              </div>
              <RadioGroup name="gender" value={form.gender}>
                <RadioInput id={`radio-gender-male-${index}`} value="男" onChange={onChange} />
                <label className="labelGender" htmlFor={`radio-gender-male-${index}`}>
                  男 Male
                </label>
                <RadioInput id={`radio-gender-female-${index}`} value="女" onChange={onChange} />
                <label className="labelGender" htmlFor={`radio-gender-female-${index}`}>
                  女 Female
                </label>
              </RadioGroup>
            </div>
            {/*<TextInput className="textInput col-12 col-sm-4 col-md-4 form1" value={form.birthday} type="date" name="birthday" label={'生年月日 Birth Date'} onChange={e => onChange(e)} />*/}
            <TextInput className="textInput form1" value={form.age} type="number" name="age" label={'年齢 Age'} option="required" onChange={e => onChange(e)} />

            <div className="form1">
              <div className="textInput__label textInput__label- textInput__label-required">
                誕生日 Birthday
                <div className="textInput__optionIcon" />
              </div>
              <select className="dropdown" style={{ display: 'inline', width: '40%' }} name="birthmonth" value={form.birthmonth} onChange={onChange}>
                <option value={''}>Please Select</option>
                {[
                  { label: '1月 January', value: 1 },
                  { label: '2月 February', value: 2 },
                  { label: '3月 March', value: 3 },
                  { label: '4月 April', value: 4 },
                  { label: '5月 May', value: 5 },
                  { label: '6月 June', value: 6 },
                  { label: '7月 July', value: 7 },
                  { label: '8月 August', value: 8 },
                  { label: '9月 September', value: 9 },
                  { label: '10月 October', value: 10 },
                  { label: '11月 November', value: 11 },
                  { label: '12月 December', value: 12 }
                ].map(opt => (
                  <option value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <select className="dropdown" style={{ display: 'inline', width: '40%', marginLeft: '4px' }} name="birthday" value={form.birthday} onChange={onChange}>
                <option value={''}>Please Select</option>
                {[...Array(31)].map((o, i) => (
                  <option value={i + 1}>{i + 1}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="row">
            <TextInput className="textInput form1" value={form.phone} type="tel" name="phone" label={'電話番号 Phone Number'} onChange={onChange} />
            <div className="form1">
              <div className="textInput__label textInput__label- textInput__label-required">
                職業 Occupation
                <div className="textInput__optionIcon" />
              </div>
              <select className="dropdown" name="business" value={form.business} onChange={onChange}>
                <option value={''}>Please Select</option>
                {Occupations.map(opt => (
                  <option value={opt.value}>{opt.label}</option>
                ))}
              </select>
              {/*<Dropdown className="dropdown" name="business" searchable={true} isClearable={false} options={Occupations} value={form.business} onChange={onChange} />*/}
            </div>
            <div className="form1">
              <div className="textInput__label textInput__label- textInput__label-required">
                国籍 Nation
                <div className="textInput__optionIcon" />
              </div>
              <select className="dropdown" name="nation" value={form.nation} onChange={onChange}>
                <option value={''}>Please Select</option>
                {Nations.map(opt => (
                  <option value={opt.value}>{opt.label}</option>
                ))}
              </select>
              {/*<Dropdown className="dropdown" name="nation" searchable={true} isClearable={false} options={Nations} value={form.nation} onChange={onChange} />*/}
            </div>
          </div>
          <div className="row">
            <TextInput className="textInput form2" value={form.email} type="email" name="email" label={'メールアドレス Email'} onChange={onChange} />
          </div>

          {r.renderIf(form.nation === 'Japan')(
            <div className="row">
              <div className="textInput__label textInput__label">都道府県 Prefecture</div>
              <select className="dropdown" name="prefecture_id" value={form.prefecture_id} onChange={onChange}>
                <option value={''}>選択してください (For Japanese)</option>
                {props.prefectures.map(opt => (
                  <option value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}

          <div className="row">
            <TextInput className="textInput form2" value={form.address} type="text" name="address" label={'住所 Address'} option="required" onChange={onChange} />
          </div>
          <div className="row">
            <TextInput className="textInput form2" value={form.arrival} type="date" name="arrival" label={'チェックイン Check in'} placeholder={'2018/01/01'} onChange={onChange} />
            <TextInput className="textInput form2" value={form.departure} type="date" name="departure" label={'チェックアウト Check out'} placeholder={'2018/01/02'} onChange={onChange} />
          </div>
          <div className="row" style={{ padding: '1rem' }}>
            <Checkbox
              label={'海外国籍 Foreign Nationality'}
              value={form.with_passport}
              onClick={() => {
                CheckInAction.onEdit(token, { target: { name: 'with_passport', value: !form.with_passport, props: props.children } }, index)
              }}
              isSelected={form.with_passport}
            />
          </div>
          {r.renderIf(form.with_passport)(
            <div>
              <p style={{ marginBottom: '8px' }}>
                パスポート Passport <span style={{ color: 'red' }}>*</span>
              </p>
              <FileInput
                default={'Choose File'}
                label={form.passport_url ? form.passport_url.replace(/.*\/|[^.]*\/$/g, '') : null}
                name="passport_url"
                type="img"
                accept="image/*"
                capture="camera"
                onChange={onChange}
                onClear={() => CheckInAction.disposePassport(reservationId, form.passport_url, index)}
              />
              {r.renderIf(form.passport_image)(
                <div>
                  <img className="image" src={form.passport_image} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

function DeleteDialog(props) {
  const form = props.children
  const index = props.index

  if (!form.showConfirmDeletion) {
    return null
  }

  return (
    <div className="deleteDialog">
      <p>
        宿泊者#
        {index} を削除しますか？
      </p>
      <p>Do you want to delete Guest #{index} ?</p>
      <div className="buttonGroup">
        <NormalButton type="dark" size="lg" onClick={e => props.onCloseDeletionDialog(e, index)}>
          いいえ No
        </NormalButton>
        <CarefulButton type="danger" size="lg" onClick={e => props.onFormDeletion(e, index, form)}>
          削除 Delete
        </CarefulButton>
      </div>
    </div>
  )
}

export default InputForms
